import { useParams } from "react-router-dom";
import Navigation from "../components/Navigation/Navigation";

const NavigationDynamicPage = () => {
  const { id } = useParams();
  return <Navigation currentNavigationName={id} />;
};

export default NavigationDynamicPage;
